import apiClient from '../client.js'
import * as Sentry from '@sentry/vue'

export const cartAPI = {
  // Cart management
  async getCart() {
    const response = await apiClient.get('/cart')
    return response.data?.data || null
  },

  async addItem(itemData) {
    const response = await apiClient.post('/cart/items', itemData)
    return response.data?.data || null
  },

  async updateItem(cartItemId, itemData) {
    const response = await apiClient.put(`/cart/items/${cartItemId}`, itemData)
    return response.data?.data || null
  },

  async removeItem(cartItemId) {
    const response = await apiClient.delete(`/cart/items/${cartItemId}`)
    return response.data?.data || null
  },

  async applyDiscount(discountCode) {
    const response = await apiClient.post('/cart/apply-discount', { code: discountCode })
    return response.data?.data || null
  },

  async removeDiscount() {
    const response = await apiClient.delete('/cart/remove-discount')
    return response.data?.data || null
  },

  async clearCart() {
    const response = await apiClient.delete('/cart/clear')
    return response.data?.data || null
  },

  // Authenticated cart operations
  async transferCart(guestCartId) {
    const response = await apiClient.post('/cart/transfer', { guest_cart_id: guestCartId })
    return response.data?.data || null
  },

  // Quote operations
  async createQuoteFromCart(data) {
    const response = await apiClient.post('/quotes', data)
    return response.data
  },

  // Get cart with B2B pricing
  async getCartWithPricing() {
    const response = await apiClient.get('/cart/pricing')
    return response.data?.data || null
  }
}
